import React from 'react';
import { Plus, Minus } from 'lucide-react';
import { RichText } from './RichText';
interface BlogFaqItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
  lang: string;
  accent: 'teal' | 'red';
}
const accentClasses = {
  teal: {
    hover: 'group-hover:text-teal-600',
    open: 'bg-teal-600 text-white',
    link: 'text-teal-700 underline underline-offset-2 hover:text-teal-900'
  },
  red: {
    hover: 'group-hover:text-red-600',
    open: 'bg-red-600 text-white',
    link: 'text-red-700 underline underline-offset-2 hover:text-red-900'
  }
};
export function BlogFaqItem({
  question,
  answer,
  isOpen,
  onToggle,
  lang,
  accent
}: BlogFaqItemProps) {
  const c = accentClasses[accent];
  return <div className="border-b border-gray-100 last:border-b-0" data-id="element-224" data-mp="fg9wu8ej8pny">
      <button type="button" onClick={onToggle} aria-expanded={isOpen} className="w-full flex items-center justify-between py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-300 rounded group" data-id="element-225" data-mp="aeasav723mpf">
        <span className={`text-lg font-medium text-gray-900 transition-colors ${c.hover}`} data-id="element-226" data-mp="ie308e92zdwc">
          {question}
        </span>
        <span className={`flex-shrink-0 ml-4 w-6 h-6 rounded-full flex items-center justify-center transition-colors ${isOpen ? c.open : 'bg-gray-100 text-gray-400'}`} aria-hidden="true" data-id="element-227" data-mp="3mu3zmaoaua8">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-228" data-mp="11cnrq7evwlai" /> : <Plus className="w-4 h-4" data-id="element-229" data-mp="11bmcrruqzeni" />}
        </span>
      </button>
      <div className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-230" data-mp="ncwdc5kgh2vz">
        <div className="overflow-hidden" data-id="element-231" data-mp="rgcb5589h9a9">
          <p className="text-gray-600 leading-relaxed pb-4" data-id="element-232" data-mp="382vjc9hxx1vy">
            <RichText text={answer} lang={lang} linkClassName={c.link} data-id="element-233" data-mp="385hoy3l9t7bj" />
          </p>
        </div>
      </div>
    </div>;
}